// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CaseChannel_wrapper__3Vt-f","title":"CaseChannel_title__1L_QI"};